import { TIERS, COMPLIANCE, CONSULTING, CONSULTING_NOTE } from "@/lib/pricing";

function TierCard({ t }) {
  const cardStyle = t.highlight
    ? "border-[#09090B] bg-[#FFCC00] ws-hard-shadow"
    : "border-[#09090B] bg-white ws-hard-shadow-sm";
  return (
    <div data-testid={t.testid} className={`border-2 p-6 flex flex-col ${cardStyle}`}>
      <div className="ws-label text-[#FF5A00]">{t.name}</div>
      <div className="mt-3 font-display font-black text-4xl tracking-tighter">{t.price}</div>
      <div className="text-xs text-[#52525B] mt-1">{t.priceSub}</div>
      {t.setup && (
        <div className="mt-4 border-t-2 border-dashed border-[#09090B] pt-3 text-sm font-semibold">
          {t.setup}
        </div>
      )}
      {t.includes && <p className="mt-3 text-sm text-[#52525B] leading-relaxed">{t.includes}</p>}
    </div>
  );
}

function ComplianceBlock() {
  return (
    <div className="border-2 border-[#09090B] p-6 bg-[#F4F4F5]" data-testid="pricing-compliance">
      <div className="ws-label text-[#FF5A00]">Compliance Evaluation &amp; Documentation Service</div>
      <div className="mt-3 font-display font-black text-2xl tracking-tighter">{COMPLIANCE.evaluation}</div>
      <ul className="mt-3 space-y-1 text-sm">
        {COMPLIANCE.plans.map((p) => (
          <li key={p.name} data-testid={`compliance-plan-${p.name.toLowerCase()}`}>
            <span className="font-semibold">{p.name}</span> {p.price} {COMPLIANCE.unit}
          </li>
        ))}
      </ul>
      <ul className="mt-3 space-y-1 text-xs text-[#52525B] leading-relaxed">
        {COMPLIANCE.notes.map((n) => <li key={n}>{n}</li>)}
      </ul>
    </div>
  );
}

function ConsultingBlock() {
  return (
    <div className="border-2 border-[#09090B] p-6 bg-[#F4F4F5]" data-testid="pricing-consulting">
      <div className="ws-label text-[#FF5A00]">Consulting</div>
      <ul className="mt-3 space-y-1 text-sm">
        {CONSULTING.map((c) => (
          <li key={c.label}>
            <span className="font-semibold">{c.label}</span> {c.price}
            {c.note && <span className="text-[#52525B]"> ({c.note})</span>}
          </li>
        ))}
      </ul>
      <p className="mt-3 text-xs text-[#52525B] leading-relaxed">{CONSULTING_NOTE}</p>
    </div>
  );
}

export default function PricingTable() {
  return (
    <section className="border-b-2 border-[#09090B] bg-white" data-testid="pricing-table">
      <div className="max-w-5xl mx-auto px-6 md:px-12 py-16">
        <div className="ws-label text-[#FF5A00]">/ 04 — Pricing</div>
        <h2 className="font-display font-black text-3xl sm:text-4xl tracking-tighter mt-3">
          Subscriptions, per site per month, plus one-time setup per site.
        </h2>
        <p className="mt-3 text-[#52525B] max-w-2xl leading-relaxed">
          WorkSafeStory is licensed as part of the WorkSafeAgent platform. Contact us to enroll a site.
        </p>
        <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {TIERS.map((t) => <TierCard key={t.name} t={t} />)}
        </div>
        <div className="mt-6 grid md:grid-cols-2 gap-4">
          <ComplianceBlock />
          <ConsultingBlock />
        </div>
      </div>
    </section>
  );
}
